var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"form-builder cognito",attrs:{"id":"c-admin"}},[_c('div',{ref:"buildContainer",staticClass:"form-builder__container c-app-container",attrs:{"id":"c-forms-build"}},[_c('BuilderLayout',{key:_vm.builderKey})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }